export { TenderReportsComponent } from './tender-reports.component';
